module.exports = __webpack_public_path__ + "img/edit_stickers.776100b.png";